














import Vue, { PropOptions } from 'vue'
import { PRINTING_METHOD } from '@/search/const'

interface SearchTag {
  label: string
  valueName: string
}

export default Vue.extend({
  props: {
    tagCategory: {
      type: String,
      default: ''
    },
    tagUnitPrice: {
      type: String,
      default: ''
    },
    tagIndustry: {
      type: Array,
      required: true
    },
    tagPrintingMethod: {
      type: Object,
      required: true
    } as PropOptions<{ items: string[] }>,
    tagFacets: {
      type: Array as () => SearchTag[],
      required: true
    },
    tagEditPatterns: {
      type: Array as () => SearchTag[],
      required: true
    }
  },
  computed: {
    formatPrintingMethod(): { [key: string]: string }[] {
      return PRINTING_METHOD.filter(
        (item: { [key: string]: string }) => this.tagPrintingMethod.items.includes(item.value)
      )
    },
    searchTags(): string {
      return [
        ...this.tagIndustry.map((item: any) => item.displayName),
        this.tagCategory,
        this.tagUnitPrice,
        ...this.formatPrintingMethod.map(item => item.label),
        ...this.tagEditPatterns.map(item => item.label),
        ...this.tagFacets.map(item => item.valueName)
      ].filter(Boolean).join('、 ')
    }
  }
})
